import { connect } from 'react-redux'
import { getPlaybookType, getLandingPageSettings, getLandingPageSubdomain, getLandingPageCname, getOnboardingPlaybookId } from 'modules/playbook/selectors'
import ClpWoohoo from 'layouts/OnboardingPlaybookWoohooStep/ClpWoohoo'

const mapStateToProps = (state) => {
  return {
    playbookType: getPlaybookType(state),
    playbookId: getOnboardingPlaybookId(state),
    landingPageSettings: getLandingPageSettings(state),
    landingPageSubdomain: getLandingPageSubdomain(state),
    landingPageCname: getLandingPageCname(state),
  }
}

export default connect(mapStateToProps, null)(ClpWoohoo)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/ClpWoohooStep/index.js